import { OnlineApplicationDetailComponent } from './../dashboard/online-application-detail/online-application-detail.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardLayoutComponent } from './dashboard-layout/dashboard-layout.component';
import { DashHomeComponent } from './dash-home/dash-home.component';
import { AssetsComponent } from './assets/assets.component';
import {UserRolesComponent} from '../full-pages-admin-panel/user-mgt/user-roles/user-roles.component';
import {EmployeeComponent} from '../full-pages-admin-panel/employee-mgt/employee/employee.component';
import {UserPrivilegeComponent} from '../full-pages-admin-panel/user-mgt/user-privilege/user-privilege.component';
import {EmployeeDesignationComponent} from '../full-pages-admin-panel/employee-mgt/employee-designation/employee-designation.component';
import {UserRolesCategoryComponent} from '../full-pages-admin-panel/user-mgt/user-roles-category/user-roles-category.component';
import {AssignWorkflowStageComponent} from '../full-pages-admin-panel/assign-workflow-stage/assign-workflow-stage.component';
import {ProvinceComponent} from '../full-pages-admin-panel/location-mgt/province/province.component';
import {DistrictComponent} from '../full-pages-admin-panel/location-mgt/district/district.component';
import {CityComponent} from '../full-pages-admin-panel/location-mgt/city/city.component';
import {NationalityComponent} from '../full-pages-admin-panel/nationality-mgt/nationality/nationality.component';
import {RequestSearchComponent} from './request-search/request-search.component';
import { DashboardNewComponent } from './dashboard-new/dashboard-new.component';
import {RequestSearchHistoryComponent} from './request-search/request-search-detail/request-search-history/request-search-history.component';
import {RequestSearchDetailComponent} from './request-search/request-search-detail/request-search-detail.component';
import {InventoryDetailsComponent} from '../full-pages-admin-panel/inventory-details/inventory-details.component';
import {PaymentDetailComponent} from '../reports/payment-detail-report/payment-detail/payment-detail.component';
import {RequestSearchDateWiseComponent} from './request-search-date-wise/request-search-date-wise.component';
import {AuditTraceDetailsComponent} from '../reports/audit-trace-report/audit-trace-details/audit-trace-details.component';
import {BoarderMgtComponent} from '../full-pages-admin-panel/boarder-mgt/boarder-mgt.component';
import {SmsReportComponent} from '../reports/sms-report/sms-report.component';
import {SmsMgtComponent} from '../full-pages-admin-panel/sms-mgt/sms-mgt.component';
import {StageChangeMgtComponent} from '../full-pages-admin-panel/stage-change-mgt/stage-change-mgt.component';
import {StudioStatusReportComponent} from '../reports/studio-status-report/studio-status-report.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard/dashHome',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
        {
            path: 'dashHome',
            component: DashHomeComponent
        },
        {
          path: 'dashboard-new',
          component: DashboardNewComponent
        },
        {
            path: 'online-application-details/:referanceId/:type',
            component: OnlineApplicationDetailComponent
        },
      {
        path: 'request-search/:requestId',
        component: RequestSearchDetailComponent
      },
        {
          path: 'assets',
          component: AssetsComponent
      },
      {
        path: 'request',
        component: RequestSearchComponent
      },
      {
        path: 'request-date-wise',
        component: RequestSearchDateWiseComponent
      },
      {
        path: 'payment-report',
        component: RequestSearchComponent
      },
      {
        path: 'user-role',
        component: UserRolesComponent
      },
      {
        path: 'user-role-category',
        component: UserRolesCategoryComponent
      },
      {
        path: 'assign-workflow-stage',
        component: AssignWorkflowStageComponent
      },
      {
        path: 'employee',
        component: EmployeeComponent
      },
      {
        path: 'employee-designation',
        component: EmployeeDesignationComponent
      },
      {
        path: 'user-privilege',
        component: UserPrivilegeComponent
      },
      {
        path: 'province',
        component: ProvinceComponent
      },
      {
        path: 'district',
        component: DistrictComponent
      },
      {
        path: 'city',
        component: CityComponent
      },

      {
        path: 'sms',
        component: SmsMgtComponent
      },

      {
        path: 'nationality',
        component: NationalityComponent
      },
      {
        path: 'history',
        component: RequestSearchHistoryComponent
      },
      {
        path: 'inventory',
        component: InventoryDetailsComponent
      },
      {
        path: 'border-control',
        component: BoarderMgtComponent
      },
      {
        path: 'payement-detail-report',
        component: PaymentDetailComponent
      },
      {
        path: 'audit-trace-report',
        component: AuditTraceDetailsComponent
      },

      {
        path: 'sms-report',
        component: SmsReportComponent
      },
      {
        path: 'stage-change',
        component: StageChangeMgtComponent
      },
      {
        path: 'studio-status',
        component: StudioStatusReportComponent
      },

    ],
}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule {
}
